import { reactive, ref, computed, onMounted } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import * as apiContract from '@/api/contract'

// 購入方法選択画面
export const getGroupIndex = () => {
  const group1 = reactive({
    // webSessionを取得したかどうか
    isWebSessionFetched: false,
    // ログイン済みかどうか
    isWebSessionValid: false,

    /**
     * ログインボタンクリックでwebセッションログイン条件初期化
     */
    onClickLoginButton: () => {
      group1.isWebSessionFetched = false
    },

    /**
     * 契約申込みフォームボタンクリック
     */
    onClickNewApplicationButton: () => {
      const params = {}
      params.member_param = group1.member_param
      return apiContract.getWebSession(params)
        .then(response => {
          group1.isWebSessionFetched = true
          if (response) {
            const { data } = response
            const status = data.status
            if (status === 0) {
              // WEBセッション情報取得API ログイン済みの場合
              group1.isWebSessionValid = true
              router.push('/public/new-application/index')
            } else {
              // WEBセッション情報取得API 未ログインの場合
              group1.isWebSessionValid = false
            }
          }
        })
        .finally(() => {
          store.dispatch('common/hideLoading')
        })
    }
  })
  return group1
}
